<template>
  <aside
    class="w-full md:w-64 bg-[#1F1F1F] text-white border-b md:border-b-0 md:border-r border-gray-700"
  >
    <nav
      class="flex flex-wrap md:flex-col items-center md:items-start justify-start md:justify-start gap-2 px-4 py-4"
    >
      <NuxtLink
        to="/admin"
        class="sidebar-link"
        exact-active-class="active-link"
      >
        📊 Dashboard
      </NuxtLink>

      <NuxtLink
        to="/admin/users"
        class="sidebar-link"
        exact-active-class="active-link"
      >
        👤 Kullanıcılar
      </NuxtLink>

      <NuxtLink
        to="/admin/moduls"
        class="sidebar-link"
        exact-active-class="active-link"
      >
        ⭐ Modül
      </NuxtLink>

      <NuxtLink
        to="/admin/blocks"
        class="sidebar-link"
        exact-active-class="active-link"
      >
        ⭐ Modül Yönetimi
      </NuxtLink>
      <NuxtLink
        to="/admin/blogs"
        class="sidebar-link"
        exact-active-class="active-link"
      >
        📝 Bloglar
      </NuxtLink>

      <NuxtLink
        to="/admin/contacts"
        class="sidebar-link"
        exact-active-class="active-link"
      >
        💬 İletişim
      </NuxtLink>
    </nav>
  </aside>
</template>

<style scoped>
.sidebar-link {
  @apply px-3 py-2 text-sm md:text-base rounded hover:bg-gray-700 whitespace-nowrap transition bg-[#2A2A2A];
}
.active-link {
  @apply bg-teal-100 text-teal-800 font-bold;
}
</style>
